import { BaseSelect, Select, SelectProps } from '@app/components';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { PromotionItemDiscountStrategy } from '@app/common';
import React from 'react';

const columnHelper = createColumnHelper<PromotionItemDiscountStrategy>();

export const getLabel = (strategy: PromotionItemDiscountStrategy) => {
  switch (strategy) {
    case PromotionItemDiscountStrategy.ALL:
      return "Tous les articles ciblés";
    case PromotionItemDiscountStrategy.CHEAPEST:
      return "Article le moins cher";
    case PromotionItemDiscountStrategy.MOST_EXPENSIVE:
      return "Article le plus cher";
    case PromotionItemDiscountStrategy.BEST_VALUE:
      return "Article le plus intéressant pour le client";
  }
}

const columns = [
  columnHelper.display({
    id: 'type',
    header: () => (
      <BaseSelect.ListHeaderItem width="100%">
        Type
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => {
      return <BaseSelect.ListItemCol width="100%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {getLabel(info.row.original)}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    },
  }),
];

export const PromotionItemDiscountStrategySelect = ({ label = 'Stratégie de remise', ...props }: Omit<SelectProps<any>, 'table'>) => {
  const table = useReactTable({
    data: Object.values(PromotionItemDiscountStrategy),
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Select
      label={label}
      table={table}
      transform={{
        accessor: (item) => item,
        value: (item) => item,
        display: (item) => getLabel(item)
      }}
      {...props} />
  );
};
